import {
    USERS_SET_USER_PINNED_STATE,
    USERS_SET_USER_MULTILAUNCH_STATE,
    USERS_LOGIN_USER,
    USERS_LOGOUT_USER,
    PROFILE_SHOW_SELECTOR,
    PROFILE_HIDE_SELECTOR,
    USERS_SET_USER_PROFILE,
    LOGGER_LOG,
} from '../constants'

const LoggerMiddleware = () => next => (action) => {
    switch (action.type) {
        // Log changes to pinned state
        case USERS_SET_USER_PINNED_STATE: {
            // Complete the action
            const result = next(action)
            const payload = action.payload
            console.info(
                `Pinned state set to ${payload.pinned} for ${payload.userKey} on ${payload.server}`,
            )
            return result
        }

        // Log changes to multi-launch state
        case USERS_SET_USER_MULTILAUNCH_STATE: {
            // Complete the action
            const result = next(action)
            const payload = action.payload

            console.info(
                `Multi-launch ${payload.multiLaunch ? 'enabled' : 'disabled'} for ${
                    payload.userKey
                } on ${payload.server}`,
            )
            return result
        }

        // When user login is completed
        case USERS_LOGIN_USER: {
            // Complete the action
            const result = next(action)
            const payload = action.payload

            console.info(
                `Logging in '${payload.user.username}' with pin ${
                    payload.user.remember ? 'enabled' : 'disabled'
                } (${payload.server})`,
            )
            return result
        }

        // X logout button on user line
        case USERS_LOGOUT_USER: {
            // Complete the action
            const result = next(action)
            const payload = action.payload

            console.info(`Logging out ${payload.userKey} (${payload.server})`)
            return result
        }

        // Toggle for profile selector in user line
        case PROFILE_HIDE_SELECTOR:
        case PROFILE_SHOW_SELECTOR: {
            // Complete the action
            const result = next(action)

            if (action.payload) {
                const user = action.payload.user
                console.info(`Profile selector opened for ${user}`)
            } else {
                console.info('Profile selector closed')
            }
            return result
        }

        // Log the new profile selected
        case USERS_SET_USER_PROFILE: {
            const result = next(action)
            const payload = action.payload

            console.info(
                `User profile update: ${payload.userKey} will use '${payload.profile}' on ${
                    payload.server
                }`,
            )

            return result
        }

        // Log whatever is sent our way
        case LOGGER_LOG: {
            const result = next(action)
            console.info(action.payload)
            return result
        }

        default:
            return next(action)
    }
}

export default LoggerMiddleware



// WEBPACK FOOTER //
// ./src/middlewares/LoggerMiddleware.js